import styled, { css } from 'styled-components';

import { getColorByName } from '~/helpers/getColors';
import getFontFamily from '~/helpers/getFontFamily';

export const MobileTableContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledTable = styled.table`
  width: 100%;
  table-layout: fixed;
  @media (${(props) => props.theme.table.mobileSwitch}) {
    border-top: 2px solid ${(props) => props.theme.color.white500};
    border-bottom: 3px solid ${(props) => props.theme.color.white500};
    background-color: ${(props) =>
      getColorByName(props.theme, props.theme.table.brightCellBgColor)};
    &:nth-child(odd) {
      background-color: ${(props) =>
        getColorByName(props.theme, props.theme.table.darkCellBgColor)};
    }
  }
`;

export const TableRow = styled.tr`
  background-color: ${(props) =>
    getColorByName(props.theme, props.theme.table.brightCellBgColor)};
  &:nth-child(odd) {
    background-color: ${(props) =>
      getColorByName(props.theme, props.theme.table.darkCellBgColor)};
  }
  @media (${(props) => props.theme.table.mobileSwitch}) {
    background-color: transparent;
    &:nth-child(odd) {
      background-color: transparent;
    }
  }
`;

const TableCommonStyles = css`
  padding: 15px 3%;
  min-width: 10rem;
  word-break: break-word;
  border: 1px solid ${(props) => props.theme.color.white500};
  text-align: left;
`;

export const TableHead = styled.th`
  ${TableCommonStyles};

  background-color: ${(props) =>
    getColorByName(props.theme, props.theme.table.headerBgColor)};
  color: ${(props) =>
    getColorByName(props.theme, props.theme.table.headerFontColor)};
  font-family: ${(props) => getFontFamily(props.theme.table.headerFont)};
  font-size: 18px;
  @media (${(props) => props.theme.table.mobileSwitch}) {
    min-width: 30%;
    font-size: 16px;
    padding: 8px;
  }
`;

export const TableCell = styled.td`
  ${TableCommonStyles};

  font-size: 16px;
  vertical-align: top;
  color: ${(props) => getColorByName(props.theme, props.theme.table.fontColor)};
  @media (${(props) => props.theme.table.mobileSwitch}) {
    width: 70%;
    padding: 8px 15px;
  }
`;
